<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import SummaryPage from "./SummaryPage.svelte"
    import {summaryPageState} from "./summary";
</script>
<StepsProgressBar currentPage={4}/>
<AppComponent previousPage="#/users" nextPage="#/quote" nextPageEnabled={$summaryPageState}>
    <SummaryPage/>
</AppComponent>
